import { Button, ELanguage } from '@microfrontends/react-components'
import { DropdownFooterWrapper } from './DropdownFooter.css'
import translationResource from '../../../../translations.json'
import { useTranslation } from '../../../../hooks'
import { ReactNode } from 'react'
interface IDropdownFooterParams {
    handleClickClearAll: () => void
    handleMoreFilterApply: () => void
    onClose: () => void
    filterNumber: number
    langCode: ELanguage
    urgentJobComponent: ReactNode
}

const DropdownFooter = (params: IDropdownFooterParams) => {
    const { filterNumber, handleClickClearAll, handleMoreFilterApply, onClose, urgentJobComponent } = params
    const translate = useTranslation(translationResource)

    const onClickSearch = () => {
        handleMoreFilterApply()
        onClose()
    }

    const onClickClear = () => {
        handleClickClearAll()
        onClose()
    }

    return (
        <DropdownFooterWrapper>
            <div>{urgentJobComponent}</div>
            <div>
                <Button type='default' onClick={onClickClear} disabled={filterNumber === 0}>
                    {translate(filterNumber > 1 ? 'Clear filters' : 'Clear filter')}
                </Button>
                <Button type='primary' onClick={onClickSearch}>
                    {translate('Search')}
                </Button>
            </div>
        </DropdownFooterWrapper>
    )
}

export default DropdownFooter
